export const EVENT_DETAILS = "EVENT_DETAILS";
export const EVENT_LIST = "EVENT_LIST";
export const EVENT_STORE_LIST = "EVENT_STORE_LIST";
export const ERROR_PAGE = "ERROR_PAGE";
export const REGISTER = "REGISTER";
